import React from "react"
import { ChevronExpandIcon, ChevronUpIcon, ChevronDownIcon } from "components/Elements/Icons"

export const TableHeader = ({
	headerGroups,
	isSortable = true,
	rowClassName = "flex-row",
	columns,
}) => {
	const getOrderIcon = (column) => {
		if (column?.hideSortIcon) return <></>
		return column.isSorted ? (
			column.isSortedDesc ? (
				<ChevronDownIcon size="17px" color="white" />
			) : (
				<ChevronUpIcon size="17px" color="white" />
			)
		) : (
			<ChevronExpandIcon size="22px" color="white" />
		)
	}

	const getColumnSize = React.useCallback((columnName) => {
		// sum should be 24
		switch (columnName) {
			case columns[0].accessor:
				return "c-table__cell--7"
			case columns[1].accessor:
			case columns[2].accessor:
			case columns[3].accessor:
			case columns[6].accessor:
				return "c-table__cell--3"
			case columns[4].accessor:
				return "c-table__cell--4"
			case columns[5].accessor:
				return "c-table__cell--2"
			default:
				return "flex-initial"
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<thead>
			{
				// Loop over the header rows
				headerGroups.map((headerGroup) => (
					// Apply the header row props
					<tr className="c-table__row" {...headerGroup.getHeaderGroupProps()}>
						{
							// Loop over the headers in each row
							headerGroup.headers.map((column, index) => (
								// Apply the header cell props
								<th
									className={`c-table__cell p-5 ${
										column.className || ""
									} ${getColumnSize(column?.id)}`}
									{...(isSortable &&
										column.getHeaderProps(column.getSortByToggleProps()))}
									key={index}
								>
									<span className="u-ellipsis">
										{isSortable && getOrderIcon(column)}
										<span className="ml-2 font-semibold">
											{column.render("Header")}
										</span>
									</span>
								</th>
							))
						}
					</tr>
				))
			}
		</thead>
	)
}
